import FloatingStars from "./FloatingStars";

// Mobile-first app shell: centered ~500px container over a pastel desktop background.
export default function AppShell({ children, stars = true }) {
  return (
    <div className="min-h-screen w-full flex justify-center py-0 sm:py-6">
      <div
        data-testid="app-shell"
        className="relative w-full max-w-[500px] min-h-screen sm:min-h-[calc(100vh-3rem)] bg-[#FFF8E7] overflow-hidden shadow-none sm:shadow-2xl sm:rounded-[32px]"
        style={{ boxShadow: "0 20px 60px rgba(255,105,180,0.25)" }}
      >
        {stars && <FloatingStars />}
        <div className="relative z-10 px-5 pb-10 pt-6">{children}</div>
      </div>
    </div>
  );
}
